<template>
  <div>
    <div class="flex">
      <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
      <SideBar />
      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col gap-3 h-full p-6">
          <div
            class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 pb-2"
          >
            <div>
              <h2 class="text-xl font-bold text-gray-800">
                Certificate Records ({{ complete_detail.length || 0 }})
              </h2>
              <p class="text-sm text-gray-500 mt-1">
                View and manage Learner certificates
              </p>
            </div>
            <div class="relative w-full md:max-w-80">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                type="text"
                v-model="search_title"
                @input="fetchstudent()"
                placeholder="Search..."
                class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              />
              <button
                v-if="search_title"
                @click="clearSearch"
                class="absolute inset-y-0 right-0 pr-3 flex items-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400 hover:text-gray-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>

          <div
            class="w-full overflow-x-auto rounded-lg border border-gray-200 shadow-sm overflow-hidden"
          >
            <table class="min-w-full text-sm">
              <thead class="bg-gray-100">
                <tr>
                  <th
                    class="py-3 px-4 border text-center border-r text-textblues whitespace-nowrap"
                  >
                    S NO
                  </th>
                  <th class="py-3 px-4 border text-center border-r text-textblues">
                    Learner Name
                  </th>
                  <th class="py-3 px-4 border text-center border-r text-textblues">
                    Email
                  </th>
                  <th
                    class="py-3 px-4 border text-center border-r text-textblues whitespace-nowrap"
                  >
                    Start Date
                  </th>
                  <th
                    class="py-3 px-4 border text-center border-r text-textblues whitespace-nowrap"
                  >
                    End Date
                  </th>
                  <th class="py-3 px-4 border text-center border-r text-textblues">
                    Progress
                  </th>
                  <th class="py-3 px-4 border text-center border-r text-textblues">
                    Certificate
                  </th>
                  <th class="py-3 px-4 border text-center border-r text-textblues">
                    Status
                  </th>
                </tr>
              </thead>

              <tbody
                v-if="complete_detail.length > 0"
                class="divide-y divide-gray-100"
              >
                <tr
                  v-for="(el, index) in complete_detail"
                  :key="el.course_id"
                  class="hover:bg-gray-50 transition"
                >
                  <td
                    class="py-3 px-4 border-b text-center border-r text-blue-600"
                  >
                    {{ (currentPage - 1) * 10 + index + 1 }}
                  </td>
                  <td class="py-3 px-4 border-b text-center border-r">
                    <p class="text-gray-800">{{ el.display_name || "NA" }}</p>
                  </td>
                  <td
                    class="py-3 px-4 border-b text-center border-r whitespace-nowrap"
                  >
                    <p class="text-gray-700">{{ el.email || "NA" }}</p>
                  </td>
                  <td
                    class="py-3 px-4 border-b text-center border-r whitespace-nowrap"
                  >
                    <p class="text-gray-700">
                      {{ el.start_time ? formatDate(el.start_time) : "NA" }}
                    </p>
                  </td>
                  <td
                    class="py-3 px-4 border-b text-center border-r whitespace-nowrap"
                  >
                    <p class="text-gray-700">
                      {{ el.end_time ? formatDate(el.end_time) : "NA" }}
                    </p>
                  </td>
                  <td class="py-3 px-4 border-b text-center border-r">
                    <div class="flex items-center justify-center gap-2">
                      <div class="w-16 bg-gray-200 rounded-full h-1.5">
                        <div
                          class="bg-blues h-1.5 rounded-full transition-all duration-500"
                          :style="{ width: el.percentage || 0 }"
                        ></div>
                      </div>
                      <span
                        class="text-xs font-medium text-gray-700 min-w-[32px]"
                      >
                        {{ el.percentage || 0 }}
                      </span>
                    </div>
                  </td>
                  <td class="py-3 px-4 border-b text-center border-r">
                    <a
                      :href="el.image"
                      target="_blank"
                      class="text-blue-600 hover:text-blue-800 underline cursor-pointer"
                    >
                      View
                    </a>
                  </td>
                  <td class="py-3 px-4 border-b text-center border-r">
                    <label
                      class="relative inline-block w-12 h-7 sm:w-10 sm:h-5"
                    >
                      <input
                        type="checkbox"
                        class="peer opacity-0 w-0 h-0"
                        :checked="el?.certificate_provide"
                        @change="handleToggle(el)"
                      />
                      <!-- Track -->
                      <span
                        :class="[
                          'absolute cursor-pointer top-0 left-0 right-0 bottom-0 rounded-full transition duration-300',
                          el.certificate_provide
                            ? 'bg-[#22c55e]'
                            : 'bg-red-500',
                        ]"
                      ></span>

                      <!-- Knob -->
                      <span
                        :class="[
                          'absolute border border-white rounded-full transition duration-300',
                          'bottom-[5px] left-[4px] h-5 w-5 sm:h-[15px] sm:w-[15px] sm:bottom-[2.5px] sm:left-[2px]',
                          el?.certificate_provide
                            ? 'translate-x-[22px] sm:translate-x-[18px] bg-white'
                            : 'translate-x-0 bg-white',
                        ]"
                      ></span>
                    </label>
                  </td>
                </tr>
              </tbody>

              <tbody v-else>
                <tr class="w-full">
                  <td colspan="7" class="text-center py-6">
                    <div class="w-full flex justify-center items-center">
                      No Data Found
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div
        v-if="showPopup"
        class="fixed bg-black bg-opacity-50 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
      >
        <div
          class="lg:w-[40%] 2xl:w-[30%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
        >
          <div class="w-full flex flex-col relative rounded-2xl">
            <div class="w-full flex flex-col gap-8">
              <h1
                v-if="this.checkbox_status == false"
                class="font-bold text-sm text-red-400 text-center"
              >
                Do You Want To Hide The Certificate For
                <span class="text-sm text-textblues">
                  <span v-if="pendingItem.display_name">{{
                    pendingItem.display_name
                  }}</span>
                  <span v-else>{{ dep_email }}</span> </span
                >?
              </h1>
              <h1 v-else class="font-bold text-sm text-green-400 text-center">
                Do You Want To Show The Certificate For
                <span class="text-sm text-textblues">
                  <span v-if="pendingItem.display_name">{{
                    pendingItem.display_name
                  }}</span>
                  <span v-else>{{ dep_email }}</span></span
                >?
              </h1>
              <div class="flex items-center justify-center gap-5">
                <button
                  @click="cancelToggle"
                  class="bg-blues hover:bg-hover text-white rounded-xl text-sm font-semibold px-6 py-2"
                >
                  No
                </button>
                <button
                  @click="confirmToggle"
                  class="bg-blues hover:bg-hover text-white rounded-xl text-sm font-semibold px-6 py-2"
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/Instructor/SideBar.vue";
import Pagination from "@/components/Pagination.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import FlashMessage from "@/components/FlashMessage.vue";

export default {
  components: {
    SideBar,
    Pagination,
    FlashMessage,
  },

  props: ["course_id"],

  data() {
    return {
      currentPage: 1,
      studentTotalPages: 1,
      complete_detail: [],
      search_title: "",
      certificate_enable: false,
      showPopup: false,
      pendingItem: null,
      dep_email: "",
      checkbox_status: false,
      messages: {
        text: "",
        type: "null",
      },
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  created() {
    this.fetchstudent();
  },

  methods: {
    handleToggle(item) {
      if (item) {
        this.pendingItem = item;
        this.dep_email = item.email;
        this.showPopup = true;
        if (item.certificate_provide == true) {
          this.checkbox_status = false;
        } else {
          this.checkbox_status = true;
        }
      }
    },
    cancelToggle() {
      this.pendingItem = null;
      this.showPopup = false;
    },
    confirmToggle() {
      if (this.pendingItem) {
        this.updateStatus(this.pendingItem, false);
        this.pendingItem = null;
        this.showPopup = false;
      }
    },

    async updateStatus(item) {
      let acceptsVal = {};
      if (item.certificate_provide == true) {
        acceptsVal = {
          certificate_provide: false,
        };
      } else {
        acceptsVal = {
          certificate_provide: true,
        };
      }

      axios
        .put(
          `${process.env.VUE_APP_API}/student-certificate/${item.id}/?Key=${this.userInfo.token_key}`,
          acceptsVal,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            console.log("successful");
            this.fetchstudent(1);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            console.log("not successful");
          }
        })
        .catch((error) => {
          this.messages = {
            text: error.response.data.error,
            type: "error",
          };
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 3000);
    },
    clearSearch() {
      this.search_title = "";
      this.fetchstudent();
    },

    async fetchstudent() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/completed-certificates/`,
          {
            params: {
              Key: this.userInfo.token_key,
              lesson_track__lesson_id__course_name__id: this.course_id,
              search: this.search_title,
              lesson_track__lesson_id__course_name__certificate_enable: true,
            },
          },
        );
        this.complete_detail = response.data.data;
      } catch (error) {
        console.error("Failed to fetch students:", error);
      }
    },

    onSearchInput() {
      this.currentPage = 1;
      if (this.$refs.studentPagination) {
        this.$refs.studentPagination.resetPage?.();
      }
      this.fetchstudent(1);
    },

    formatDate(date) {
      return new Date(date).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
